import { BitkitAlert } from '@bitrise/bitkit-v2';
import { useContext, useState } from 'react';

import { GlobalPropsContext } from '@/components/page/GlobalPropsContext';
import { GlobalPropsWithAccount } from '@/models/GlobalProps';
import { getCookie, setCookie } from '@/utils/cookies';

type GoToInstallableArtifactDetailsAlertProps = {
  hasInstallableArtifacts: boolean;
};

const GoToInstallableArtifactDetailsAlert = ({ hasInstallableArtifacts }: GoToInstallableArtifactDetailsAlertProps) => {
  const { account } = useContext(GlobalPropsContext) as GlobalPropsWithAccount;

  const goToInstallableArtifactDetailsDismissedCookie = `go_to_installable_aftifact_details_dismissed_${account.slug}`;

  const [cookieValue, setCookieValue] = useState(() => getCookie(goToInstallableArtifactDetailsDismissedCookie));

  const handleClose = () => {
    setCookieValue('false');
    setCookie(goToInstallableArtifactDetailsDismissedCookie, 'true', { cookieOptions: { expires: 365 * 10 } });
  };

  return (
    hasInstallableArtifacts &&
    !cookieValue && (
      <BitkitAlert
        variant="info"
        dismissible
        onClose={handleClose}
        messageText="To share a link or install an artifact on a device, go to the detailed view of an installable app package."
      />
    )
  );
};

export default GoToInstallableArtifactDetailsAlert;
